// Le web n'a pas de mise à jour OTA : chaque chargement sert déjà le dernier déploiement. Ce fichier
// le garde hors de `launchUpdate.js`, dont le module web d'`expo-updates` se dirait pourtant actif.
export const useLaunchUpdate = () => true
